import log from 'uix/logging'
import {treeAspect, wikiTab, isBadType2} from 'uix/views/utils'

export const tree = {
  ...treeAspect,
  acl: 'g:viewTree',
  tabs: {
    list: {
      tabGroup: 'overview',
      enabled: ({datatype, subtype, treeNode}) =>
        !(datatype == 2 && subtype == 52) &&
        ([10, 2, 1, 0, 7, 17, 16, 13, 19, 21, 23, 24].includes(datatype) ||
          treeNode.nodeType.startsWith('domain:')),
      parts: ['TreeList'],
    },
    home: wikiTab({
      acl: 'g:wiki',
      ident: 'home',
      tabGroup: 'overview',
    }),
    titles: {
      acl: 'g:admin',
      parts: ['ViewerTitleList'],
      tabGroupDefault: true,
      tabGroup: 'titles',
      enabled: ({datatype, subtype, treeNode}) =>
        !isBadType2(datatype, subtype) &&
        ([10, 2].includes(datatype) || treeNode.nodeType == 'domain:all'),
    },
    viewer: {
      acl: 'g:admin',
      datatype: [0, 1, 3],
      parts: [{type: 'ViewerGrid', optionSet: 'simple', filters: ['structuredImageLocationsJson']}],
      tabGroup: 'titles',
    },
    history: {
      datatype: [10],
      tabGroup: 'titles',
      acl: 'g:debug',
      parts: [
        {
          type: 'ReleaseHistory',
          filters: [
            {
              cacheKeys: ['dname', 'cname', 'max', 'limit', 'withFacets'],
              type: 'getReleaseHistory',
            },
          ],
        },
      ],
    },
    index: {
      parts: [{type: 'AllDocuments', name: 'AllDocuments', filters: ['getAllDocuments']}],
      customClass: 'managedScrollbars',
      datatype: [10],
      tabGroup: 'titles',
      acl: 'g:debug',
    },

    pdf: {tabGroup: 'overview', acl: 'g:debug', datatype: [1], parts: ['PDFViewer']},
    bibformat: {
      datatype: [1, 2, 10],
      acl: 'g:admin',
      tabGroup: 'formats',
      parts: ['BibFormats'],
      order: 20,
    },
    i3f: {
      datatype: [1],
      acl: 'g:admin',
      tabGroup: 'formats',
      parts: ['I3FDetails'],
      order: 21,
    },
  },
}
